import React, { useContext, useEffect, useState } from 'react';
import { WebEngageContext } from '@/context/webengageContext';
import Script from 'next/script';
import { useProfileContext } from '@/context/profileContext';
import LocalStorage from '@/utils/localStorage';
import { WE_PHONE, COUNTRY_CODE } from '@/constants/app';

interface WebengageInitProps {
  weKey: string;
}

export default function WebengageInit({ weKey }: WebengageInitProps) {
  const { dispatch: webengageDispatch } = useContext(WebEngageContext);
  const { state: profile } = useProfileContext();
  const [loaded, setLoaded] = useState(false);
  const { webEngageId } = profile || {};

  useEffect(() => {
    if (loaded) {
      window?.webengage?.init(weKey);
      webengageDispatch.webengageScriptInitialized(true);
    }
  }, [loaded]);

  useEffect(() => {
    if (loaded && webEngageId) {
      const mobileNumber = LocalStorage.get(WE_PHONE);
      window?.webengage?.user?.login(webEngageId);
      if (mobileNumber) {
        window?.webengage?.user?.setAttribute(WE_PHONE, `${COUNTRY_CODE}${mobileNumber}`);
        LocalStorage.remove(WE_PHONE);
      }
    }
  }, [webEngageId, loaded]);

  return (
    <>
      <Script
        strategy="afterInteractive"
        id="_webengage_script_tag"
        src="/js/webengage.js"
        onLoad={() => setLoaded(true)}
      />
    </>
  );
}
